
export default {
  name: 'Fb',
  layout: 'empty',

  data() {
    return {
      products: [
        {
          name: 'p1',
          price: 10,
        },
        {
          name: 'p2',
          price: 20,
        },
      ],
    };
  },

  computed: {
    header() {
      return Object.keys(this.products[0]);
    },
    csv() {
      return (
        `${this.header.join(',')}` +
        '\n' +
        this.products.map((p) => Object.values(p).join(',')).join('\n')
      );
    },
  },
};
